export default __webpack_public_path__ + "static/home-left-img-d3b0f6903f2f0c8bffd97b677fec5be7.png";